module.exports = __webpack_public_path__ + "static/media/hero-image-2.c1b81724.png";